// Need to use the React-specific entry point to allow generating React hooks
import {createApi, fakeBaseQuery} from '@reduxjs/toolkit/query/react';
import hybrid from '@zoom/hybrid-jssdk';


// Define a service using a base URL and expected endpoints
export const hybridSdkApi = createApi({
  reducerPath: 'hybridSdkApi',
  baseQuery: fakeBaseQuery(),
  tagTypes: ['MobileShareCapabilities'],
  endpoints: (builder) => ({
    // Mobile Share Capabilities should be platform device specific and cachable.
    getMobileShareCapabilities: builder.query({
      queryFn: async () => {
        try {
          const res = await hybrid.mobile.getShareCapabilities();
          if (res.returnCode === 0) {
            return {data: res.result};
          } else {
            console.warn('getShareCapabilities failed:', res.errorMsg || res);
            return {error: res.errorMsg || res};
          }
        } catch (e) {
          console.warn('exception while getShareCapabilities:', e);
          return {error: e.message};
        }
      },
      providesTags: ['MobileShareCapabilities'],
    }),
  }),
});

// Export hooks for usage in function components, which are
// auto-generated based on the defined endpoints
export const {
  useGetMobileShareCapabilitiesQuery,
} = hybridSdkApi;
